<div class="container">
  @switch (page) {
    @case (Page.Media) {
      <app-media
        class="page page--media"
        [showBrowserProblemLink]="showBrowserProblemLink"
        (confirmMedia)="handleConfirmMedia()"
      ></app-media>
    }
    @case (Page.MediaError) {
      <app-media-error
        class="page page--media"
        [showBrowserProblemLink]="showBrowserProblemLink"
      ></app-media-error>
    }
    @case (Page.OrientationError) {
      <app-orientation-error
        class="page page--media"
        [showBrowserProblemLink]="showBrowserProblemLink"
      ></app-orientation-error>
    }
    @case (Page.Check) {
      @if (loadingStatus === LoadingStatus.Success) {
        <app-check
          class="page page--check"
          #checkPage
          [video]="video"
          [stream]="stream"
          (requestVideo)="handleRequestVideo()"
          (changeMedia)="handleChangeMedia()"
          (fileReady)="handleFileReady($event)"
        ></app-check>
      }
    }
    @case (Page.Upload) {
      <app-uploading-processor
        [progressMessage]="progressMessage"
        [progress]="progress"
      ></app-uploading-processor>
    }
  }

  <app-video #video [visible]="showVideo"></app-video>
</div>
